import styled from "styled-components";
import { ContainerSection } from "@/main/components/shared/styles";

export const Container = styled(ContainerSection)`
	@media (max-width: 426px) {
		button {
			width: 100%;
			max-width: 100%;
			padding: 0.4rem 0 !important;
			margin: 0;
		}
	}
`;
